var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tests"}},[_c('h2',[_vm._v("See All Tests")]),_vm._l((_vm.tests),function(test){return _c('show-test',{key:test.id,attrs:{"test":test}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }